export default __webpack_public_path__ + "static/media/fb-taraftart-card-gray.3e999965.png";